export function deleteErrors(inputs) {
  inputs.forEach(input => {
    // if (input.name === 'telefono') return
    input.addEventListener('input', () => {
      const error = input.parentElement.querySelector('.custom-budget__error')
      if (error !== null) error.remove()
    })
  })
}
